import { InjectionToken } from '@angular/core';

export type DealsDataConfig = {
  apiPrefix: string;
};

export const DEALS_DATA_CONFIG = new InjectionToken<DealsDataConfig>(
  'deals-data-config',
);
